// extracted by mini-css-extract-plugin
export default {"tabsContainer":"y0dXLZgX","tabs":"C8Wwucu9","Mui-selected":"SzRRbVTV","activeTab":"fXTQWoi9","divider":"OywtkLN1","projectTab":"oJCHcQ8b","tabTitle":"XTP369Iz"};